import PlacesController from './places.controller';
import template from './places.html';

const PlacesComponent = {
    template,
    controller: PlacesController,
};

export default PlacesComponent;
